var map = {
	"./add.svg": 1834,
	"./align-center.svg": 1835,
	"./align-left.svg": 1836,
	"./align-right.svg": 1837,
	"./arrow-down.svg": 1838,
	"./arrow-up.svg": 1839,
	"./base-module-drag.svg": 1840,
	"./button-content.svg": 1841,
	"./cancel.svg": 1842,
	"./check.svg": 1843,
	"./close.svg": 1844,
	"./code-transparent.svg": 1845,
	"./code.svg": 1846,
	"./collapse.svg": 1847,
	"./content.svg": 1848,
	"./context-menu.svg": 1849,
	"./crop.svg": 1850,
	"./delete.svg": 1851,
	"./download.svg": 1852,
	"./drag.svg": 1853,
	"./duplicate.svg": 1854,
	"./edit.svg": 1855,
	"./expand.svg": 1856,
	"./external-window.svg": 1857,
	"./fill-blue.svg": 1858,
	"./filter.svg": 1859,
	"./fit-blue.svg": 1860,
	"./google-maps.svg": 1861,
	"./hidden.svg": 1862,
	"./image.svg": 1863,
	"./internal-window.svg": 1864,
	"./lock.svg": 1865,
	"./move.svg": 1866,
	"./navigation.svg": 1867,
	"./options.svg": 1868,
	"./page.svg": 1869,
	"./plus.svg": 1870,
	"./preferences.svg": 1871,
	"./radiobutton-off.svg": 1872,
	"./radiobutton-on.svg": 1873,
	"./refresh.svg": 1874,
	"./reset.svg": 1875,
	"./resize-vertical.svg": 1876,
	"./retoggle.svg": 1877,
	"./save.svg": 1878,
	"./settings.svg": 1879,
	"./slider.svg": 1880,
	"./text-left.svg": 1881,
	"./text.svg": 1882,
	"./title.svg": 1883,
	"./toggle.svg": 1884,
	"./trash.svg": 1885,
	"./unlock.svg": 1886,
	"./upload.svg": 1887
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1833;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons \.svg$
// module id = 1833
// module chunks = 0